import PhoneOTPCard from "./PhoneOTPCard";
function LoginViaPhoneOtp() {
  return (
    <>
      <PhoneOTPCard />
    </>
  );
}

export default LoginViaPhoneOtp;
